import InputTypesEnum from "../../../Enums/InputTypesEnum";
import IobLineItemSearchParams from "./IobLineItemSearchParams";

export default class IobLineItemOtherSearchParams extends IobLineItemSearchParams {

    static fieldsInSearchBox = [
        { fieldName: "IoblineItemId", label: "Line Item ID", className: "col-4", type: InputTypesEnum.Text },
        { fieldName: "Type", label: "Type", className: "col-4", type: InputTypesEnum.MultiChoice, options: IobLineItemSearchParams.getSelectValuesForType() },
		{ fieldName: "SelectedStatuses", label: "Status", className: "col-4", type: InputTypesEnum.MultiChoice, options: IobLineItemSearchParams.getStatusValues() },
        { fieldName: "Description", label: "Description", className: "col-4", type: InputTypesEnum.Text },
    ];
}